<template>
  <div id="app">
    <navigation />
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="font-none" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="font-none" />
    <navigation-bottom />
  </div>
</template>

<script>
import navigation from '@/components/navigation/index.vue'
import navigationBottom from '@/components/navigation-bottom/index.vue'
export default {
  components: {
    navigation,
    navigationBottom
  },
  data() {
    return {
      url: ''
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
 .ads--RPf__ {
  display: none !important;
 }
</style>
